import React from 'react';

import Form from '../../../../../../components/Form/Form/';

import './UpdateUser.scss';

class UpdateUser extends React.Component {
  render () {
    const isDisabled = value => {
      if (Object.prototype.hasOwnProperty.call(this.props.authedUser, 'User')) {
        if (Object.prototype.hasOwnProperty.call(this.props.authedUser.User, value)) {
          return {
            'disabled': true,
          };
        }
      }

      if (value === 'password') {
        if (!Object.prototype.hasOwnProperty.call(this.props.authedUser, 'freshCreate')) {
          return {
            'disabled': true,
            'value': 'hunter2!'
          };
        }
      }

      return {};
    };

    let DefaultUserValues = {};
    if (Object.prototype.hasOwnProperty.call(this.props.authedUser, 'User')) {
      DefaultUserValues = this.props.authedUser.User;
      delete DefaultUserValues['id'];
    }

    return (
      <div className='CreateCompany__Wrapper'>
        <h2 className='FormSegment__title'>Create your account</h2>
        <Form defaultValue={this.props.authedUser.User} onChange={this.props.handleUserChange}>
          <div className='row'>
            <div className='col-md'>
              <input type='text' placeholder='First Name' className='Form__Input' name='first_name' {...isDisabled('first_name')} />
            </div>
            <div className='col-md'>
              <input type='text' placeholder='Last Name' className='Form__Input' name='last_name' {...isDisabled('last_name')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-md'>
              <input type='text' placeholder='Email' className='Form__Input' name='email' {...isDisabled('email')} />
            </div>
            <div className='col-md'>
              <input type='password' placeholder='Password' className='Form__Input' name='password' {...isDisabled('password')} />
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default UpdateUser;



// WEBPACK FOOTER //
// ./src/routes/company/routes/Create/components/UpdateUser/index.js